import { useState, useEffect, memo, useMemo } from 'react';
import { Box, Typography } from '@material-ui/core';
import { elStyle } from '../common/ContractTableHandlerCss';
import Utils from '@/common/utils/utils';
import { caculatorDiscount } from './UpdateContractHandler';
import { renderDisplayPayment } from '../NormalViewContractDetailHanlder';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function Payment({
    amountValue,
    setAmountValue,
    paymentData, 
    product,
    updateContractData,
    version,
    paymentCycle,
    contractDetail,
    versionCurrent
}) {
    useTranslationSubscription();
    const priceDiscount = useMemo(() => {
        const paymentDiscount = caculatorDiscount(
            updateContractData.basicSetting, 
            updateContractData.advanceSetting, 
            version, 
            product.increaseRate,
            contractDetail,
            versionCurrent
        );
        localStorage.setItem('discountContract', paymentDiscount);
        return paymentDiscount;
    }, [updateContractData.basicSetting, updateContractData.advanceSetting, version, paymentCycle, product.increaseRate, contractDetail]);
    
    const [discount, setDiscount] = useState(priceDiscount);

    useEffect(() => {
        if(!Utils.isEmptyObject(product)) {
            setDiscount(priceDiscount);
        }
    }, [product, priceDiscount])

    useEffect(() => {
        setAmountValue(Number(paymentData) - Number(discount) <= 0 ? 0 : Number(paymentData) - Number(discount));
    }, [paymentData, discount])

    return (
        <Typography component="div" className="total-price">
            <Box className="price-label" {...elStyle.total_price_label} component="span">
                {trI18n('LABEL-TITLE-UPDATE-CONTRACT')}
            </Box>
            {discount > 0 && (
                <>
                    <Box className="payment-price" {...elStyle.total_value}>
                        <Box component="span" {...elStyle.fw500}>
                            {trI18n('LABEL-TOTAL-VALUE')}
                        </Box>
                        <Box component="span" {...elStyle.fz14_grey}>
                            {paymentData} {renderDisplayPayment(paymentCycle, contractDetail)}
                        </Box>
                    </Box>
                    <Box className="label-discount" {...elStyle.label_discount}>
                        <Box component="span" {...elStyle.fw500}>
                            {trI18n('LABEL-DISCOUNT')}
                        </Box>
                        <Box component="span" {...elStyle.fz14_grey}>
                            {discount} {renderDisplayPayment(paymentCycle, contractDetail)}
                        </Box>
                    </Box>
                </>
            )}

            <Box className="total-value" {...elStyle.payment_price}>
                <Box component="span" {...elStyle.fw500}>
                    {trI18n('LABEL-PAYMENT-AMOUNT')}
                </Box>
                <Box component="span" {...elStyle.fz14}>
                    {amountValue} {renderDisplayPayment(paymentCycle, contractDetail)}
                </Box>
            </Box>
        </Typography>
    );
}

export default memo(Payment);